import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

// Material 19's NativeDateAdapter derives the first weekday from the locale (`Intl.Locale.getWeekInfo`), which
// turns the en-GB and nl calendars Monday-first. Every calendar in these apps started on Sunday up to Angular 18;
// this keeps that until the change is made deliberately. Its own file so pauly-shop can use it without pulling in
// SharedUiMaterialModule.
@Injectable()
export class SundayFirstNativeDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 0;
  }
}
